import * as SelectPrimitive from "@radix-ui/react-select";
import { ComponentProps } from "react";
import {
  GSMServiceKind,
  ServiceKindList,
} from "@/services/backend/services/types/kinds";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";

export function ServiceKindSelect({
  availableServiceKinds = ServiceKindList,
  ...props
}: ComponentProps<typeof SelectPrimitive.Root> & {
  availableServiceKinds?: GSMServiceKind[];
}) {
  return (
    <Select {...props}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Dienstleistung auswählen" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {availableServiceKinds.map((serviceKind) => (
            <SelectItem value={serviceKind} key={serviceKind}>
              {serviceKind}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
